import { createContext, useContext } from 'react';

// False while a Presence subtree is playing its exit; dialogs inside release focus handling immediately.
export const PresentContext = createContext(true);
export const usePresent = (): boolean => useContext(PresentContext);
